import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableProps } from '../../types';
import { CellCenterWrapper } from '../../styles';
import { Button } from '../../../../../../../components';
import { BLACKLIST_DOMAINS } from '../../../enums';

export const Edit = ({
  val, row, setOpenModal, setModalInfo, isReadOnly,
}: TableProps) => (
  <CellCenterWrapper>
    <Button
      onClick={() => {
        setOpenModal();
        setModalInfo({
          id: row.id,
          domain: row.domain,
          checked: row.checked,
          type: BLACKLIST_DOMAINS.MODAL.TYPES.EDIT,
        });
      }}
      theme="quaternary"
      disabled={isReadOnly}
    >
      <FontAwesomeIcon icon={val} />
    </Button>
  </CellCenterWrapper>
);
